// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  ssId: __t.u64().primaryKey().name("ss_id"),
  gameId: __t.u64().name("game_id"),
  seasonId: __t.u64().name("season_id"),
  player: __t.identity(),
  bestScore: __t.i64().name("best_score"),
});
